export const checkoutUrgencyStatuses = {
  inactive: 'inactive',
  running: 'running',
  runningAndModalOpen: 'runningAndModalOpen',
  finishedAndModalOpen: 'finishedAndModalOpen',
  loading: 'loading',
}

export const checkoutUrgencyDefaultStartSeconds = 25 * 60
export const checkoutUrgencyDefaultModalSeconds = 3 * 60
export const checkoutUrgencyDefaultCriticalSeconds = 1 * 60
